import React, { useEffect, useState } from 'react';

export const triggerHaptic = (pattern = 10) => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

/**
 * Tikslus įrenginio aptikimas:
 * 1. User Agent — ar tai mobilus įrenginys
 * 2. Lango plotis < 768px — papildoma apsauga
 */
const detectMobile = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(ua);
  const isNarrow = window.innerWidth < 768;
  return isMobileUA || isNarrow;
};

/**
 * variant="side"   (default) — choices kairėje, targets dešinėje (desktop)
 * variant="bottom" — choices viršuje, targets apačioje pilnu pločiu (pvz. number line)
 */
const DragDropLayout = ({ choices, targets, hud, variant = 'side' }) => {
  const [isMobile, setIsMobile] = useState(() => detectMobile());

  useEffect(() => {
    const handleResize = () => setIsMobile(detectMobile());
    window.addEventListener('resize', handleResize);

    const updateVh = () => {
      if (window.visualViewport) {
        document.documentElement.style.setProperty(
          '--real-vh',
          `${window.visualViewport.height}px`
        );
      }
    };
    updateVh();
    window.visualViewport?.addEventListener('resize', updateVh);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('resize', updateVh);
    };
  }, []);

  return (
    <>
      {isMobile ? (
        /* ══════════════════════════════════════
           MOBILAUS LAYOUTAS (telefonas / planšetas)
           ══════════════════════════════════════ */
        <div
          className="flex flex-col overscroll-none"
          style={{ height: 'var(--real-vh, 100dvh)' }}
        >
          <div className="flex-shrink-0 z-50 p-2">
            {hud}
          </div>

          <div
            className="flex-1 overflow-y-auto overscroll-contain"
            style={{ WebkitOverflowScrolling: 'touch', paddingBottom: '48vh' }}
          >
            <div className="px-2 pt-2">
              {choices}
            </div>
          </div>

          <div
            className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-4 border-slate-200 shadow-[0_-8px_30px_rgba(0,0,0,0.12)] overflow-hidden"
            style={{ height: '46vh', maxHeight: '460px' }}
          >
            <div
              className="h-full overflow-y-auto overscroll-contain px-2 py-2"
              style={{ WebkitOverflowScrolling: 'touch' }}
            >
              {targets}
            </div>
          </div>
        </div>
      ) : (
        /* ══════════════════════════════════════
           DESKTOP LAYOUTAS (kompiuteris / didelis langas)
           ══════════════════════════════════════ */
        <div
          className="flex flex-col overscroll-none"
          style={{ height: '100dvh' }}
        >
          <div className="flex-shrink-0 z-50 p-4 pb-2">
            {hud}
          </div>

          {variant === 'bottom' ? (
            /* choices viršuje, targets apačioje pilnu pločiu */
            <div className="flex flex-col flex-1 overflow-hidden gap-4 px-4 pb-4">
              <div className="flex-1 overflow-y-auto overscroll-contain rounded-2xl" style={{ minWidth: 0 }}>
                <div className="py-4">{choices}</div>
              </div>
              <div className="flex-shrink-0 overflow-hidden rounded-2xl border-t-4 border-slate-100" style={{ maxHeight: '52vh' }}>
                <div className="h-full overflow-auto overscroll-contain p-2">
                  {targets}
                </div>
              </div>
            </div>
          ) : (
            /* choices kairėje, targets dešinėje */
            <div className="flex flex-row flex-1 overflow-hidden gap-4 px-4 pb-4">
              <div
                className="flex-1 overflow-y-auto overscroll-contain rounded-2xl"
                style={{ minWidth: 0 }}
              >
                <div className="py-4">{choices}</div>
              </div>

              <div
                className="targets-column flex-shrink-0 overflow-hidden flex flex-col border-l-4 border-slate-100"
                style={{ width: 'min(400px, 36vw)', minWidth: '280px', contain: 'layout style' }}
              >
                <div className="flex-1 overflow-y-auto overscroll-contain py-4 px-3">
                  {targets}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DragDropLayout;